const NutriavesTheme = {
    images : {
        loginLogo: "/img/nutriaves/login-logo.png",
        whiteLogo: "/img/nutriaves/login-logo.png",
        favicon: "/img/nutriaves/favicon.ico",
        leftMenuLogo: "/img/nutriaves/logo-only.png",
        touchIconIphone: "/img/touch-icon-iphone.png",
        touchIconIpad:"/img/touch-icon-ipad.png",
        touchIconIphoneRetina: "/img/touch-icon-iphone-retina.png",
        touchIconIpadRetina: "/img/touch-icon-ipad-retina.png",
        appleTouchStartupImage: "/img/apple-touch-startup-image"
    },
    css: [
        "/themes/nutriaves/nutriaves.css"
    ],
    strings: {
        title: "Nutriaves - Product Monitorization"
    }
}

export default NutriavesTheme;